export default __webpack_public_path__ + "static/media/btn_big_arbitrum.9c7ad5cc.png";